import 'bootstrap';
// JavaScript
import './scripts/main';

// Styles
import './scss/main.scss';
import './scss/admin-style.scss';

(function ($) {

})(jQuery);